import React, { useState, useEffect, useContext, useRef } from 'react'
import { useFetch, usePost } from '../../../components/component-items/helpers'
import { globalState } from '../../../store'
import GenericModal from '../../../components/component-items/modal'
import { Form, Col, Row } from 'react-bootstrap'

// Components
import GlobalStyles from '../../../components/component-items/styles'
import { ModalProps } from './types'

export const AddressModal = ({ open, setOpen }: ModalProps) => {
  const defaultAddress = {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zip: '',
    country: 'US',
    phone: '',
  }
  const [address, setAddress] = useState(defaultAddress)
  const [validated, setValidated] = useState(false)
  const node = useRef<HTMLFormElement | null>(null)

  const {
    state: { csrf, companyId },
  } = globalState()

  const res = useFetch(`/api/company/${companyId}/address/`, {})
  const loaded = res.loaded
  const resp: any = loaded ? res.response : {}

  const countries = loaded ? resp.countries : []

  useEffect(() => {
    if (loaded) {
      setAddress(resp.address)
    }
  }, [loaded])

  const handleSubmit = (event: any) => {
    event.preventDefault()
    event.stopPropagation()
    setValidated(true)

    if (node?.current?.checkValidity() === false) {
      return
    }

    usePost(`/api/company/${companyId}/address/`, { ...address }, csrf)
  }

  return (
    <GenericModal
      heading={'Company Address'}
      show={open}
      size="lg"
      onHide={() => setOpen(false)}
      buttons={
        <>
          <GlobalStyles.Button style={{ minWidth: 125 }} onClick={(e) => handleSubmit(e)}>
            Update
          </GlobalStyles.Button>
          <GlobalStyles.Button className="secondary" style={{ minWidth: 125 }} onClick={() => setOpen(false)}>
            Close
          </GlobalStyles.Button>
        </>
      }
    >
      <Form noValidate ref={node} validated={validated} onSubmit={handleSubmit}>
        <div style={{ padding: '2em', width: '-webkit-fill-available', maxWidth: 800, margin: 'auto' }}>
          <Row>
            <Form.Group as={Col} md="6" controlId="line1" className="required">
              <Form.Label>Address 1</Form.Label>
              <Form.Control
                type="text"
                placeholder="Address 1"
                value={address.line1}
                onChange={(e) => setAddress({ ...address, line1: e.target.value })}
                required
              />
              <Form.Control.Feedback type="invalid">Please provide a valid Address.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="line2">
              <Form.Label>Address 2</Form.Label>
              <Form.Control
                type="text"
                placeholder="Address 2"
                value={address.line2}
                onChange={(e) => setAddress({ ...address, line2: e.target.value })}
              />
              <Form.Control.Feedback type="invalid">Please provide a valid Address.</Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} md="6" controlId="city" className="required">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="text"
                placeholder="City"
                value={address.city}
                onChange={(e) => setAddress({ ...address, city: e.target.value })}
                required
              />
              <Form.Control.Feedback type="invalid">Please provide a valid city.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="3" controlId="state" className="required">
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                placeholder="State"
                value={address.state}
                onChange={(e) => setAddress({ ...address, state: e.target.value })}
                required
              />
              <Form.Control.Feedback type="invalid">Please provide a valid state.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="3" controlId="zip" className="required">
              <Form.Label>Zip</Form.Label>
              <Form.Control
                type="text"
                placeholder="Zip"
                value={address.zip}
                onChange={(e) => setAddress({ ...address, zip: e.target.value })}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid zip. If there is none, enter 000000
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} md="6" controlId="country" className="required">
              <Form.Label>Country</Form.Label>
              <Form.Select
                value={address.country}
                onChange={(e) => setAddress({ ...address, country: e.target.value })}
              >
                {Object.keys(countries).map((c, id) => (
                  <option value={c} key={id}>
                    {countries[c]}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">Please provide a valid country.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="phone" className="required">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Phone"
                value={address.phone}
                onChange={(e) => setAddress({ ...address, phone: e.target.value })}
                required
              />
              <Form.Control.Feedback type="invalid">Please provide a valid phone number.</Form.Control.Feedback>
            </Form.Group>
          </Row>
        </div>
      </Form>
    </GenericModal>
  )
}
